<template>
  <div class="page_background">
    <new-glas-card :title="$t('templates_component.title')">
      <templates-component />
    </new-glas-card>
  </div>
</template>


<script>

  import NewGlasCard from '@bit/new-netzportal.netzportal.new-glas-card';
  import TemplatesComponent from "../components/templates-component/TemplatesComponent";

  export default {
    name: "HomePage",
    components: {
      TemplatesComponent,
      NewGlasCard
    },
  }
</script>

<style scoped>

</style>
